import React from 'react'
import { connect } from 'react-redux'
import {
  LOGO_RENDITIONS,
} from '../../constants'
import getImageRenditions from '../../utils/getImageRenditions'
import LiveNow from './LiveNow'

const LiveNowContainer = props => <LiveNow {...props} />

const extractScheduleProps = data => ({
  title: (data?.now !== null) ? data?.now?.title : data.title,
  summary: data?.now?.summary,
  startTime: data?.now?.startTime,
  endTime: data?.now?.endTime,
  channel: data?.channel,
  sportsExclusive: data?.premierSportsExclusive,
  ...(data?.now?.programme ? {
    guid: data?.now?.programme?.guid,
    permalink: data?.now?.programme?._permalink,
    logo: getImageRenditions(data?.custom?.squareChannelImage?._filepath, LOGO_RENDITIONS),
    image: getImageRenditions(
      (data?.now !== null)
        ? data?.now?.programme?.images?.[0]?._filepath
        : data?.mobileVideoSlate?._filepath
    ),
  } : {
    guid: null,
    permalink: null,
    image: getImageRenditions(data?.mobileVideoSlate?._filepath),
    logo: getImageRenditions(data?.custom?.squareChannelImage?._filepath, LOGO_RENDITIONS),
  }),
})

const mapStateToProps = (state) => {
  const channels = state.liveChannels.data

  if (!channels.results || !Array.isArray(channels.results)) {
    return { error: true }
  }

  try {
    const channelData = channels.results.map(
      item => extractScheduleProps(item)
    )

    return {
      channelData,
      error: false,
    }
  } catch (err) {
    return { error: true }
  }
}

export default connect(mapStateToProps)(LiveNowContainer)
